import TaskService from '@/services/tasks/task-service'
import { alertSuccess } from '@/utilities/sweetalert'

export const state = {
  tasks: [],
  task: {},
  discussions: [],
  loading: {
    items: false,
    item: false,
    discussions: false
  }
}

export const getters = {
  tasks: state => state.tasks,
  task: state => state.task,
  discussions: state => state.discussions,
  loading: state => state.loading
}

export const actions = {
  fetchTasks({ commit }) {
    commit('SET_ITEMS_LOADING', true)

    TaskService.index()
      .then(response => {
        commit('SET_TASKS', response.data)
      })
      .catch(() => {
        commit('SET_TASKS', [])
      })
      .then(() => {
        commit('SET_ITEMS_LOADING', false)
      })
  },

  fetchTask({ commit }, id) {
    commit('SET_ITEM_LOADING', true)

    TaskService.show(id)
      .then(response => {
        commit('SET_TASK', response.data)
      })
      .catch(() => {
        commit('SET_TASK', {})
      })
      .then(() => {
        commit('SET_ITEM_LOADING', false)
      })
  },

  storeTask({ commit }, payload) {
    return TaskService.store(payload).then(response => {
      commit('projects/INSERT_TASK_TO_PROJECT_TASK_LIST', response.data, {
        root: true
      })

      alertSuccess({
        title: 'Task susccessfully created.'
      })
    })
  },

  updateTask({ commit }, payload) {
    return TaskService.update(payload.id, payload).then(response => {
      commit('SET_TASK', response.data)

      commit('projects/UPDATE_TASK_IN_PROJECT_TASK_LIST', response.data, {
        root: true
      })

      alertSuccess({
        title: 'Task susccessfully updated.'
      })
    })
  },

  updateTaskCompleted({ commit }, payload) {
    return TaskService.updateCompleted(payload.id, payload.completed).then(
      response => {
        commit('projects/UPDATE_TASK_IN_PROJECT_TASK_LIST', response.data, {
          root: true
        })

        alertSuccess({
          title: response.data.completed
            ? 'Task susccessfully set to completed.'
            : 'Task successfully set to uncompleted.'
        })
      }
    )
  },

  deleteTask({ commit }, id) {
    return TaskService.delete(id).then(response => {
      commit('projects/REMOVE_TASK_FROM_PROJECT_TASK_LIST', response.data, {
        root: true
      })

      commit('REMOVE_TASK_FROM_TASKS', id)
      commit('REMOVE_TASK', id)

      alertSuccess({
        title: 'Task list susccessfully deleted.'
      })
    })
  },

  fetchDiscussions({ commit }, discussable_id) {
    return TaskService.indexDiscussions(discussable_id)
      .then(response => {
        commit('SET_DISCUSSIONS', response.data)
      })
      .catch(() => {
        commit('SET_DISCUSSIONS', [])
      })
  },

  storeDiscussion({ commit }, payload) {
    return TaskService.storeDiscussion(payload.discussable_id, payload).then(
      response => {
        commit('SET_DISCUSSIONS', response.data)
      }
    )
  },

  updateDiscussion({ commit }, payload) {
    return TaskService.updateDiscussion(
      payload.discussable_id,
      payload.id,
      payload
    ).then(response => {
      commit('SET_DISCUSSIONS', response.data)
    })
  },

  deleteDiscussion({ commit }, payload) {
    return TaskService.deleteDiscussion(
      payload.discussable_id,
      payload.id
    ).then(response => {
      commit('SET_DISCUSSIONS', response.data)
    })
  }
}

export const mutations = {
  SET_TASKS(state, tasks) {
    state.tasks = tasks
  },
  SET_TASK(state, task) {
    state.task = task
  },
  SET_DISCUSSIONS(state, discussions) {
    state.discussions = discussions
  },
  SET_ITEMS_LOADING(state, loading) {
    state.loading.items = loading
  },
  SET_ITEM_LOADING(state, loading) {
    state.loading.item = loading
  },
  REMOVE_TASK_FROM_TASKS(state, id) {
    if (!state.tasks || !state.tasks.length) return

    state.tasks = state.tasks.filter(task => task.id !== id)
  },
  REMOVE_TASK(state, id) {
    if (!state.task && state.task.id !== id) return

    state.task = {}
  }
}
